/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * API object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Api = {
    getURI: function () {
        var map = {
            "habtium.es": "https://api.habtium.es/v1",
            "www.habtium.es": "https://api.habtium.es/v1",
            localhost: "http://localhost:3000/v1",
            "127.0.0.1": "http://localhost:3000/v1",
            "::1": "http://localhost:3000/v1",
            "canary.habtium.es": "https://api-canary.habtium.es/v1",
            "web.test": "http://api.test/v1",
        };

        return map[window.location.hostname] || "https://api.habtium.es/v1";
    },
    request: function (method, route, params, callback) {
        $.ajax({
            type: method,
            url: this.getURI() + route,
            data: params,
            headers: App.getSessionToken()
                ? { Authorization: "token " + App.getSessionToken() }
                : {},
        }).done(function (r) {
            callback(r);
        });
    },

    get: function (route, params, callback) {
        this.request("GET", route, params, callback);
    },

    put: function (route, params, callback) {
        this.request("PUT", route, params, callback);
    },

    post: function (route, params, callback) {
        this.request("POST", route, params, callback);
    },

    delete: function (route, params, callback) {
        this.request("DELETE", route, params, callback);
    },
};
